import "../scss/dw-mega-menu-odyscene.scss";
import activateMenu from "./activateMenu";

// wait until the window is fully loaded to run js
window.addEventListener("load", () => {
  activateMenu();
});
